<template>
  <div class="h-18 cust-bg-whatsapp">
    <el-dialog
      title=""
      :visible.sync="isShowadmin"
      :direction="direction"
      :before-close="handleClose"
      width="30%"
    >
      <template slot="title">
        <h3 class="fsize16 Add mb-0 Products text-white">Assign Chat To</h3>
      </template>
      <div>
        <div class="flex w-full gap-4 items-center">
          <div class="w-9/12">
            <el-select
              v-model="rmval"
              placeholder="Select"
              class="w-5"
              value-key="_id"
            >
              <el-option
                v-for="val in rmrecord"
                :key="val._id"
                :label="val.name"
                :value="val._id"
              >
                <div class="" @click="transfertorm(activeChat, val)">
                  {{ val.name }}
                </div>
              </el-option>
            </el-select>
          </div>
          <div class="w-3/12 flex justify-end" @click="trnsfertwo">
            <vs-button
              variant="primary"
              class="bg-primary cursor-pointer px-6 py-3 text-white rounded-lg"
              >Assign
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="flex justify-between items-center cursor-pointer px-4 py-3">
      <div class="flex items-center w-4/12">
        <span
          class="inline-block p-1 mr-2 md:hidden text-gray-600"
          @click="toggleChat(false)"
        >
          &#10096;
        </span>

        <img class="w-10 h-10 rounded-full mr-4" :src="avatar" alt="Avatar" />
        <div class="text-sm flex item-center">
          <!-- <p class="leading-none h5-class text-white">{{ activeChat.name }}</p> -->
          <p class="leading-none h5-class text-white mb-0 text-lg">
            {{ activeChat.name }}
          </p>
        </div>
      </div>
      <div class="flex gap-2 w-8/12 justify-end items-center">
        <p
          v-if="hours && hours > 0"
          class="py-2 px-4 fsize12 bg-white rounded-full border-green text-success"
        >
          {{ hours }} h
          <!-- :{{ minutes }}:{{ seconds }} -->
          <!-- {{ checkexptime(activeChat.phone) }} -->
        </p>
        <vs-button
          v-if="hours != null && hours < 0"
          class="px-4 font-semibold text-white border-daner bgred"
        >
          Expired
          <!-- :{{ minutes }}:{{ seconds }} -->
          <!-- {{ checkexptime(activeChat.phone) }} -->
        </vs-button>
        <!-- <stimers :exp="expval" /> -->
        <vs-button
          color="success"
          class="bgwhite px-5 text-col font-semibold"
          v-if="idRM !== 'RM'"
          @click="isShowadmin = true && assignchatname(activeChat)"
          >Assign Chat</vs-button
        >
        <!-- <el-dropdown v-if="idRM !== 'RM'" class="mt-1">
          <span class="el-dropdown-link">
            <feather-icon icon="MoreVerticalIcon" class="text-white" />
          </span>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="text-dark"
              ><span @click="isShowadmin = true && assignchatname(activeChat)"
                >Assign Chat</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
      <!--Dogkart Custom Start-->
      <!-- <OptionButtons /> -->
      <!-- Dogkart Custom End-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import OptionButtons from "../OptionButtons";
import stimers from "./stimers";
export default {
  data() {
    return {
      hours: null,
      minutes: "",
      seconds: "60",
      hourstatus: "",
      username: "",
      rmids: "",
      numbers: "",
      rmval: "",
      isShowadmin: false,
      expval: null,
      checkdateexp: false,
    };
  },
  components: {
    OptionButtons,
    stimers,
  },
  computed: {
    ...mapGetters("whatsappChat", {
      activeChat: "activeChat",
      avatar: "avatar",
      expStatus: "expStatus",
      contacts: "contacts",
    }),
    ...mapState("whatsappChat", {
      expStatus: "expStatus",
    }),
    ...mapState("AgentRouting", {
      rmrecord: "rmrecord",
      assignrmname: "assignrmname",
      getassigned: "getassigned",
      assignStatus: "assignStatus",
      allassignagent: "allassignagent",
    }),
    ...mapState("admin", {
      login: "login",
    }),
    idRM() {
      return this.login.role.name || "Admin";
    },
  },
  watch: {
    activeChat() {
      this.checkexptime();
    },
  },
  methods: {
    // async Startcondown() {
    //   let condownDate = new Date();
    //   condownDate.setHours(condownDate.getHours() + 24);
    //   let timer = setInterval(() => {
    //     let now = new Date().getTime();
    //     let distance = condownDate - now;
    //     if (distance < 0) {
    //       clearInterval(timer);
    //       this.hourstatus = "00";
    //       this.minutes = "00";
    //       this.seconds = "00";
    //     } else {
    //       this.hourstatus = String(
    //         Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    //       ).padStart(2, "0");
    //       this.minutes = String(
    //         Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    //       ).padStart(2, "0");
    //       this.seconds = String(
    //         Math.floor((distance % (1000 * 60)) / 1000)
    //       ).padStart(2, "0");
    //     }
    //   }, 1000);
    // },
    async checkexptime() {
      let result = this.allassignagent.filter((val) => {
        console.log(val.usermno);
        return val.usermno == this.activeChat.phone && val.isreply == false;
      });
      if (result.length > 0) {
        console.log(result, "cccccccccccc");
        let curdate = new Date();
        let timediff = Math.abs(
          curdate.getTime() - new Date(result[0].updatedAt).getTime()
        );
        this.hours = Math.floor(timediff / (1000 * 60 * 60));
        this.hours = Number(24 - this.hours);
        console.log(this.hours, "cccccccccccccccccccccccccc");
      } else {
        this.hours = null;
      }
    },
    async assignchatname(activeChat) {
      this.rmval = "";
      const payload = {
        rmid: this.login._id,
        usermno: activeChat.phone,
      };
      try {
        let { data } = await this.$store.dispatch(
          "AgentRouting/GetAssignRmName",
          payload
        );
        console.log(data, "responceresponce");
        this.rmval = this.assignrmname[0].result[0].name;
        if (this.assignrmname.length == 0) {
          this.rmval = "";
        }
      } catch (err) {
        console.log(err);
      }
    },
    async trnsfertwo() {
      try {
        const payload = {
          rmId: this.rmids,
          number: this.numbers,
          username: this.username,
        };
        let { data } = await this.$store.dispatch(
          "AgentRouting/AssignChat",
          payload
        );
        this.isShowadmin = false;
        const payload3 = {};
        await this.$store.dispatch("AgentRouting/checkChatStatus", payload3);

        this.rmval = "";
        await this.GetAllassignchat();
        await this.assignStatuss();
        if (data.code == 401) {
          this.$swal({
            text: "This chat is already assigned to this Agent",
            icon: "warning",
            timer: 1500,
            confirmButtonColor: "#CD3197",
            confirmButtonText: "OK",
          });
        } else {
          this.$swal({
            text: "Successfully assigned",
            icon: "success",
            timer: 1500,
            confirmButtonColor: "#CD3197",
            confirmButtonText: "OK",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async transfertorm(activeChat, rm) {
      (this.rmids = rm._id), (this.numbers = activeChat.phone);
      this.username = activeChat.name;
      // this.trnsfertwo(activeChat, rm)
    },
    async GTetRM() {
      let payload = {
        role: "RM",
      };
      try {
        await this.$store.dispatch("AgentRouting/GetRM", payload);
      } catch (err) {
        console.log(err);
      }
    },
    async GetAllassignchat() {
      try {
        await this.$store.dispatch("AgentRouting/GetAllassignchat");
      } catch (err) {
        console.log(err);
      }
    },
    toggleChat(val = false) {
      this.$store.commit("whatsappChat/SHOW_CHATS", val);
      this.$store.commit("whatsappChat/SHOW_CONTACTS", !val);
    },
    async assignStatuss() {
      var phoneno = [];
      this.contacts.map((val) => {
        phoneno.push(val.phone);
      });
      const payload = {
        number: phoneno,
      };
      try {
        await this.$store.dispatch("AgentRouting/assignStatus", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    await this.GTetRM();
    // await this.checkexptime()
    await this.GetAllassignchat();

    //  await this.Startcondown()
  },
};
</script>
<style>
.bg-red {
  background-color: red;
}
.bgwhite.vs-button-success.vs-button-filled {
  background-color: #fff !important;
}
.bgred.vs-button-primary.vs-button-filled {
  background-color: #ff5c5c !important;
}
.text-col {
  color: #009688 !important;
}
</style>
